import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { UnidadeMedida } from '../../types/aquisicao';
import { unidadesMedidaService } from '../../services';

const columns: ResourceColumn<UnidadeMedida>[] = [
  { header: 'Código', accessor: 'codigo' },
  { header: 'Descrição', accessor: 'descricao' },
  { header: 'Fator para ton', accessor: 'fator_para_ton' },
];

export const UnidadesMedidaListPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ResourceListPage
      title="Unidades de medida"
      description="Tabelas de unidades de medida."
      columns={columns}
      service={unidadesMedidaService}
      createPath="/admin/parametros/unidades-medida/novo"
      onEdit={(item) =>
        (item as { id?: number }).id &&
        navigate('/admin/parametros/unidades-medida/editar', { state: { record: item } })
      }
      onDelete={(item) =>
        (item as { id?: number }).id ? unidadesMedidaService.remove((item as any).id) : Promise.resolve()
      }
    />
  );
};
